export default __webpack_public_path__ + "static/media/ellipse_wallet_2.383026a2.svg";